import dayjs from "dayjs";

import type {
  LeadTimeConfigurationFormValues,
  LeadTimeConfigurationInput,
  LeadTimeRuleTarget,
} from "./types";

export const DESCRIPTION_MAX_LENGTH = 255;

export const buildLeadTimeConfiguration = (
  values: LeadTimeConfigurationFormValues,
): LeadTimeConfigurationInput => ({
  lead_time_days: Number(values.lead_time_days) || 0,
  cutoff_time: values.cutoff_time
    ? values.cutoff_time.format("HH:mm:ss")
    : null,
  cutoff_extra_days: values.cutoff_time
    ? Number(values.cutoff_extra_days) || 0
    : 0,
  description: values.description?.trim() || null,
});

export const toConfigurationFormValues = (
  target: LeadTimeRuleTarget,
): LeadTimeConfigurationFormValues => ({
  lead_time_days: target.lead_time_days,
  cutoff_time: target.cutoff_time
    ? dayjs(`2000-01-01T${target.cutoff_time}`)
    : null,
  cutoff_extra_days: target.cutoff_extra_days,
  description: target.description || undefined,
});
